import bannerImg from '../../assets/projectDetails/oilandgasmain.jpeg';
// import cardImg from '../../assets/projectDetails/card.png';
import pks from '../../assets/projectDetails/smalloilandgas.jpeg';
import rmbanner from '../../assets/projectDetails/cos1.jpg';
import rm from '../../assets/projectDetails/cos22.jpg';
import projectImg1 from '../../assets/projectDetails/secondimages.jpeg';
import projectImg2 from '../../assets/projectDetails/oilandgasthirdimage.jpeg';
import projectImg3 from '../../assets/projectDetails/waste3.jpeg';
import projectImg4 from '../../assets/projectDetails/waste4.jpeg';
import projectImg5 from '../../assets/projectDetails/oil3.jpg';
import projectImg6 from '../../assets/projectDetails/oil4.jpg';
import projectImg7 from '../../assets/projectDetails/cos3.jpeg';
import projectImg8 from '../../assets/projectDetails/cos4.jpg';
import projectImgf from '../../assets/projectDetails/warehouse4.jpg';
import projectImgq from '../../assets/projectDetails/warehouse2.jpg';
import projectImgflog from '../../assets/projectDetails/log3.webp';
import projectImgqlog from '../../assets/projectDetails/log4.webp';
import hrbg from '../../assets/projectDetails/waste22.jpeg';
import hrsmall from '../../assets/projectDetails/waste2.webp';
import logistic from '../../assets/projectDetails/warehouse1.jpeg';
import sslog from '../../assets/projectDetails/warehouse2.jpg';
import ss from '../../assets/projectDetails/warehouse3.jpeg';
import ssbg from '../../assets/projectDetails/warehouse1.jpeg';
import oop from '../../assets/projectDetails/oil2.jpg';
import oopbg from '../../assets/projectDetails/oil1.jpeg';
import blocks from '../../assets/projectDetails/blocks1.jpg';
import blocks2 from '../../assets/projectDetails/blocks2.jpg';
import blocks3 from '../../assets/projectDetails/blocks3.jpg';
import blocks4 from '../../assets/projectDetails/blocks4.jpg';
import blocks5 from '../../assets/projectDetails/blocks5.jpg';

const fakeData = [
  {
    id: 1,
    banner: bannerImg,
    title: "Project Details",
    heading: "Oil and Gas Services - Drilling Services",
    subHeading:
      "Save Energy needed to access oil reserves in a remote location with difficult terrain and limited infrastructure",
    card: {
      client: "Save Energy",
      categories: "Installation",
      date: "23 June 2017",
      tags: "Transportation and storage ",
      img: pks,
    },

    para1:
      "Solution: Our team provided a full suite of drilling services, including drilling rig setup, directional drilling, and well completion. We also managed transportation logistics for equipment and personnel to the remote site. To overcome the challenge of the remote location and difficult terrain, we utilized advanced drilling technologies such as extended reach drilling and managed pressure drilling, which allowed us to drill deeper and more efficiently while minimizing the risk of well control issues.",
    para2:
      " Our experienced personnel also worked closely with the client to ensure that safety protocols were followed and environmental impact was minimized.",
    para3:
      "The client was satisfied with the quality of work and our ability to overcome the challenges posed by the remote location, and has since engaged us for additional drilling projects in the region.",
    summary:
      "Results: By utilizing advanced drilling technologies and experienced personnel, we were able to successfully complete the drilling project on time and within budget, helping XYZ Energy to access valuable oil reserves. The project was completed with zero lost time incidents, demonstrating our commitment to safety and environmental responsibility",
    img1: projectImg1,
    img2: projectImg2,
  },
  {
    id: 2,
    banner: hrbg,
    title: "Project Details",
    heading: "Waste Management Services - Recycling Services",
    subHeading:
      "ABC Corporation was generating a significant amount of waste materials and wanted to reduce their environmental impact by increasing recycling efforts.",
    card: {
      client: "ABC Corporation",
      categories: "Waste management",
      date: "23 September 2020",
      tags: "Waste collection ",
      img: hrsmall,
    },
    para1:
      "Solution: Our team provided recycling services for a variety of materials generated by ABC Corporation, including paper, cardboard, plastics, and metals. We worked closely with the company to implement a comprehensive recycling program, including employee education and training, bin placement and signage, and regular waste audits to track progress. ",
    para2:
      "Our team also provided customized waste management solutions to meet the specific needs of the client, such as waste reduction initiatives and waste-to-energy conversion options.",
    para3:
      "Results: By increasing their recycling efforts, ABC Corporation was able to significantly reduce their waste sent to landfills, resulting in cost savings and improved environmental sustainability.",
    summary:
      "The company was also able to achieve their sustainability goals and demonstrate their commitment to environmental responsibility to stakeholders. Our team continues to work with ABC Corporation to monitor and improve their waste management practices, and the client has reported high levels of satisfaction with our services.",
    img1: projectImg3,
    img2: projectImg4,
  },
  {
    id: 3,
    banner: logistic,
    title: "Project Details",
    heading: "Logistics Services - Supply Chain Management",
    subHeading:
      "Cosmas Retailer needed to improve their inventory management processes to better track and manage their stock levels",
    card: {
      client: "Brenda parts Manufacturing",
      categories: "Logistics",
      date: "19 December 2016",
      tags: "Logistics services",
      img: sslog,
    },
    para1:
      "Solution: Our team provided comprehensive supply chain management services, including sourcing materials, managing suppliers, coordinating transportation and logistics, and overseeing inventory management. We worked closely with Brenda foods Manufacturing to develop a customized supply chain strategy that optimized costs and delivery times while maintaining quality standards",
    para2:
      "Our team also provided advanced data analytics and forecasting capabilities to help the client make informed decisions and anticipate potential supply chain disruptions.",
    para3:
      "Results: By implementing our supply chain management solutions, Brenda foods Manufacturing was able to reduce costs and improve delivery times, resulting in increased customer satisfaction and improved profitability. Our team's ability to anticipate and respond to supply chain disruptions helped to mitigate risks and maintain business continuity.",
    summary:
      "The client reported high levels of satisfaction with our services, and has since engaged us for additional supply chain management projects.",
    img1: projectImgqlog,
    img2: projectImgflog,
  },
  {
    id: 4,
    banner: oopbg,
    title: "Project Details",
    heading: "Oil and Gas Services - Drilling Services",
    subHeading:
      "Zigma Energy needed to access oil reserves in a remote location with difficult terrain and limited infrastructure..",
    card: {
      client: " Zigma Energy",
      categories: "oil and gas",
      date: "2 July 2021",
      tags: "Reservoir management",
      img: oop,
    },
    para1:
      "Solution: Our team provided a full suite of drilling services, including drilling rig setup, directional drilling, and well completion. We also managed transportation logistics for equipment and personnel to the remote site. .",
    para2:
      "By utilizing advanced drilling technologies and experienced personnel, we were able to successfully complete the drilling project on time and within budget, helping XYZ Energy to access valuable oil reserves.",
    para3:
      "Our team provided comprehensive transportation and storage solutions for Zigma Energy, including transportation logistics, pipeline construction, and storage tank installation. We also provided ongoing maintenance and repair services for the pipeline and storage tanks to ensure ongoing functionality and safety",
    summary:
      "By providing end-to-end transportation and storage solutions, we were able to help Zigma Energy maximize the value of their oil reserves and ensure a reliable supply of crude oil to the refinery.",
    img1: projectImg5,
    img2: projectImg6,
  },
  {
    id: 5,
    banner: rmbanner,
    title: "Project Details",
    heading: "Construction Services - Building Construction",
    subHeading:
      "Apex Real Estate Development wanted to construct a mixed-use building in a densely populated urban area with limited space and zoning restrictions",
    card: {
      client: "Apex Real Estate Development",
      categories: "Building construction",
      date: "1 April 2020",
      tags: "Building, renovation",
      img: rm,
    },
    para1:
      "Solution: Our team provided comprehensive building construction services, including project management, design and engineering, and construction oversight. We worked closely with the client to ensure compliance with zoning regulations and obtain necessary permits. To address the challenge of limited space, we utilized advanced construction techniques such as prefabrication and modular construction, which allowed us to build efficiently and minimize disruption to the surrounding community.",
    para2:
      "Our team also implemented a robust safety program and environmental management plan to ensure that the project was completed safely and responsibly.",
    para3:
      "Results: Our team successfully completed the construction project on time and within budget, despite the challenges posed by the urban location and limited space. The mixed-use building provided much-needed housing and commercial space in the area, and has received positive feedback from the community",
    summary:
      "The client was satisfied with the quality of work and our ability to overcome the project challenges, and has engaged us for additional construction projects.",
    img1: projectImg7,
    img2: projectImg8,
  },
  {
    id: 6,
    banner: ssbg,
    title: "Project Details",
    heading: "Warehousing Services - Inventory Management",
    subHeading:
      "Cosmas Retailer needed to improve their inventory management processes to better track and manage their stock levels",
    card: {
      client: "Cosmas Retailer",
      categories: "Warehousing",
      date: "19 December 2016",
      tags: "Warehousing services",
      img: ss,
    },
    para1:
      "Solution: Our team provided comprehensive inventory management services, including stock taking, inventory tracking, and order fulfillment. We worked closely with XYZ Retailer to implement a customized inventory management system that utilized advanced technologies such as barcoding and RFID tracking to improve accuracy and efficiency. ",
    para2:
      "Our team also provided data analytics and forecasting capabilities to help the client make informed decisions and optimize their inventory levels.",
    para3:
      "Results: By implementing our inventory management solutions, XYZ Retailer was able to improve their stock accuracy, reduce inventory carrying costs, and improve order fulfillment times. Our team's data analytics and forecasting capabilities helped the client to anticipate demand and make informed decisions about inventory levels, resulting in improved profitability.",
    summary:
      "The client was satisfied with the quality of work and our ability to improve their inventory management processes, and has engaged us for additional warehousing and logistics projects.",
    img1: projectImgq,
    img2: projectImgf,
  },
  {
    id: 7,
    banner: blocks,
    title: "Project Details",
    heading: "Building- Construction",
    subHeading:
      "Building Foundations for Tomorrow: Reliable, Innovative, and Sustainable Construction Solutions Tailored to Your Vision and Project Needs",
    card: {
      client: "Eauxwel Nig Ltd",
      categories: "Power/Electrical",
      date: "16 August 2024",
      tags: "Renewable Energy Electrical",
      img: blocks5,
    },
    para1:
      "Our team successfully completed block molding for the Eauxwell project, producing durable nine-inch blocks with precision and efficiency. Using premium cement and sharp sand, we molded and carefully stacked thousands of blocks, adhering to strict quality standards. This effort ensured a solid foundation for the client's construction goals and timelines. ",
    para2:
      "We conducted a detailed material forecast, accurately estimating cement, sand, and water requirements to minimize waste. By carefully measuring and monitoring usage, our team ensured efficient resource management, maintaining quality while preventing excess or shortages. This approach optimized costs and upheld our commitment to sustainability and operational excellence.",
    para3:
      "The results were outstanding. Our meticulous planning and execution delivered durable nine-inch blocks with consistent quality, meeting project specifications. Efficient resource management minimized waste, reducing costs and ensuring sustainability. The client was highly satisfied with the timely delivery and precision, reinforcing our reputation for excellence in block molding and construction",
    summary:
      "We delivered durable, high-quality blocks on time, minimized waste through efficient resource management, and exceeded client expectations with precision.",
    img1: blocks2,
    img2: blocks3,
  },
];
export default fakeData;